module.exports = __webpack_public_path__ + "img/Favoritos.d5d49822.svg";